import * as React from 'react';
import { ArticleHeading4, UIText2 } from '@cian/ui-kit';

import { WorkHonestly } from '../../../WorkHonestly';
import { AgentType, RgrCertificate } from '../../../RgrCertificate';
import { SuperAgentStar } from '../../../SuperAgent';
import { useApplicationContext } from '../../../../utils/applicationContext';

import * as styles from './styles.css';

interface IRealtorCardProps {
  previewImg: React.ReactNode;
  hasRgrParticipation: boolean;
  name: string;
  levelName?: string | null;
  levelNumber?: number | null;
  isSuperAgentStarShown?: boolean;
  agencyName?: string | null;
  timeOnSite?: string | null;
}

export const RealtorCard: React.FC<React.PropsWithChildren<IRealtorCardProps>> = ({
  name,
  levelName,
  levelNumber,
  hasRgrParticipation,
  agencyName,
  timeOnSite,
  previewImg,
  isSuperAgentStarShown,
}) => {
  const applicationContext = useApplicationContext();
  const superAgentsEnabled = applicationContext.config.get<boolean>('demand.Superagents.Enabled') || false;

  return (
    <div className={styles['card']}>
      <div className={styles['img']}>{previewImg}</div>
      <div className={styles['name']}>
        <ArticleHeading4 textAlign="center">{name}</ArticleHeading4>
        {superAgentsEnabled && isSuperAgentStarShown && <SuperAgentStar />}
        {!superAgentsEnabled && <WorkHonestly levelNumber={levelNumber} levelName={levelName} />}

        {!superAgentsEnabled && hasRgrParticipation && <RgrCertificate type={AgentType.Realtor} />}
      </div>

      <UIText2 color="black_60">{agencyName}</UIText2>
      <UIText2 color="black_60">{timeOnSite}</UIText2>
    </div>
  );
};

RealtorCard.displayName = 'RealtorCard';
